import ol = require("ol");
import _ = require("underscore");
import MapServer = require("arcgis/services/mapserver");
import ArcgisServices = require("../../models/arcgis-services");
import Utils = require("../../utils");
import geo = require("../../utils/geo");
import Portal = require("portal-gis");

import MapView = require("../../views/MapView");

const log = Utils.log;

class AgsLayers {

    static about = `
_asLayers_ creates app/layer-factory/arcgis-tile layers from configuration.
    `;

    static setMinMaxZoomLevel(view: MapView, tile, l) {
        // TODO: how to convert level to resolution?
        view.once("map-resolution", () => {
            var map = <ol.Map>view.model.get("map");
            var zoom = map.getView().getZoom();
            var resolution = map.getView().getResolution();

            // say zoom is 10, min is 5, max is 15, res is 1
            // then minres is 1/32, maxres is 32
            if (l.minlevel) {
                tile.setMaxResolution(resolution * Math.pow(2, zoom - (l.minlevel - 1)));
                log("set max res:", tile.getMaxResolution());
            }

            if (l.maxlevel) {
                tile.setMinResolution(resolution * Math.pow(2, zoom - l.maxlevel));
                log("set min res:", tile.getMinResolution());
            }
        });
    }

    static asLayers(service: Rhythm.GIS.ServiceEndpoint<MapServer.MapServer>) {
        var info = service.info;

        if (info.singleFusedMapCache) {
            return (() => {
                var layer = <Portal.MapLayerLeaf>{
                    basemap: true,
                    id: `${info.mapName}:${service.url}`,
                    text: _.unique(info.layers.map(l => l.name).join(" ").split(" ")).join(" "),
                    type: "app/layer-factory/arcgis-tile",
                    url: service.url,
                    Options: {
                        Values: Utils.asOptions({
                            visible: "false",
                            layerType: "tile"
                        })
                    }
                };
                return [layer];
            })();
        }

        function getLayerName(l: MapServer.Layer, seed: string = "") {
            if (typeof l.parentLayerId === "number") {
                var parentLayer = info.layers.filter(parentLayer => parentLayer.id === l.parentLayerId)[0];
                if (parentLayer) return getLayerName(parentLayer, `${parentLayer.name}/${seed}`);
            }
            if ("Layers" !== info.mapName) return `${info.mapName}/${seed}`;
            return seed;
        }

        return info.layers.map(l => {

            var showLayers = (l.subLayerIds ? l.subLayerIds.join(",") : l.id.toString());

            var layer = <Portal.MapLayerLeaf>{
                basemap: info.singleFusedMapCache,
                id: `${l.id}:${service.url}`,
                text: `${info.mapName}/${l.name}`,
                type: "app/layer-factory/arcgis-tile",
                url: service.url,
                Options: {
                    Values: Utils.asOptions({
                        visible: "false",
                        layerType: (info.singleFusedMapCache) ? "tile" : "rest",
                        showLayers: showLayers
                    })
                }
            };

            layer.text = getLayerName(l, l.name);

            if (typeof l.parentLayerId === "number") {
                var parentLayer = info.layers.filter(parentLayer => parentLayer.id === l.parentLayerId)[0];
                if (parentLayer) {
                    layer.text = `${parentLayer.name}/${l.name}`;
                }
            }

            var extent = l.extent || info.fullExtent || info.initialExtent;
            if (extent) {

                // convert to EPSG:4326
                var geom = <Rhythm.GIS.Spatial<Rhythm.GIS.Extent>>{
                    geometry: [extent.xmin, extent.ymin, extent.xmax, extent.ymax],
                    spatialReference: extent.spatialReference
                };

                geom = geo.transformExtent("EPSG:4326", geom);

                layer.extent = geom.geometry.join(",");
            }

            if (info.singleFusedMapCache && info.tileInfo) {
                // should this be level, scale, resolution?  scale and resolution are set in options?
                var firstLod = _.first(info.tileInfo.lods);
                var lastLod = _.last(info.tileInfo.lods);

                layer.minlevel = firstLod.level;
                layer.maxlevel = lastLod.level;

                Utils.setOption(layer.Options.Values, {
                    "scales": `${lastLod.scale} ${firstLod.scale}`,
                    "resolutions": `${lastLod.resolution} ${firstLod.resolution}`
                });
            }

            // eg 1950@1k, 2500@2k
            else if (l.minScale || l.effectiveMinScale || l.maxScale || l.effectiveMaxScale) {
                var minScale = l.minScale || l.effectiveMinScale || 0;
                var maxScale = l.maxScale || l.effectiveMaxScale || Infinity;
                Utils.setOption(layer.Options.Values, { "scales": `${minScale} ${maxScale}` });

                var uom = info.units;
                if (uom) {
                    var uomMap = {
                        "esriFeet": "ft",
                        "esriDecimalDegrees": "dd",
                        "esriMeters": "m"
                    };
                    if (uomMap[uom]) {
                        uom = uomMap[uom];
                        var minRes = geo.getResolutionFromScale(maxScale, uom) || 0;
                        var maxRes = geo.getResolutionFromScale(minScale, uom) || Infinity;
                        Utils.setOption(layer.Options.Values, { "resolutions": `${minRes} ${maxRes}` });
                    } else {
                        log(`${uom} has no mapping`);
                    }
                }
            }

            return layer;
        });
    }
}

export = AgsLayers;